// extracted by mini-css-extract-plugin
export default {"edit-input-box":"mTTU1_edit-input-box"};